"use client"

import { Button as AriaButton, type ButtonProps } from "react-aria-components"

import { cx } from "@uui/utils/cx"

interface EditorButtonProps extends ButtonProps {
  isActive?: boolean
}

export const EditorButton = ({
  isActive,
  isDisabled,
  className,
  children,
  ...props
}: EditorButtonProps) => {
  return (
    <AriaButton
      {...props}
      type="button"
      isDisabled={isDisabled}
      className={(state) =>
        cx(
          "text-fg-quaternary outline-focus-ring pressed:bg-primary_hover pressed:outline-hidden flex size-8 cursor-pointer items-center justify-center rounded-md p-0! transition duration-100 ease-linear focus-visible:outline-2 focus-visible:outline-offset-2",
          isActive
            ? "bg-primary_hover text-fg-secondary"
            : "hover:bg-primary_hover hover:text-fg-quaternary_hover",
          isDisabled && "cursor-not-allowed",
          typeof className === "function" ? className(state) : className,
        )
      }
    >
      {children}
    </AriaButton>
  )
}
